import { EventsTable } from "@/components/events/events-table";
import { createFileRoute } from "@tanstack/react-router";

function WebsiteEventsPage() {
  return <EventsTable />;
}

export const Route = createFileRoute("/_authenticated/website/events/")({
  component: WebsiteEventsPage,
});
